import React, { useMemo } from 'react'
import { groupPermissionsByScopeCategory } from '../../../common/scopeCategories'
import { useListOAuth2ScopesQuery } from '../../../store/permissions/permissions'
import { OAuth2AppsPermissionRow } from '../OAuth2AppManagement/OAuth2AppsPermissionRow'

interface ScopesFormFieldsProps {
  selectedScopes: string[]
  onToggle?: (scope: string) => void
  readOnly?: boolean
}

export const ScopesFormFields: React.FC<ScopesFormFieldsProps> = ({ selectedScopes, onToggle, readOnly = false }) => {
  const { data: scopesResponse } = useListOAuth2ScopesQuery()
  const availableScopes = useMemo(() => scopesResponse?.data ?? [], [scopesResponse?.data])

  const scopesToDisplay = useMemo(
    () => (readOnly ? availableScopes.filter((scope) => selectedScopes.includes(scope.id)) : availableScopes),
    [readOnly, selectedScopes, availableScopes],
  )

  const groupedScopes = useMemo(() => groupPermissionsByScopeCategory(scopesToDisplay), [scopesToDisplay])

  return (
    <>
      {Array.from(groupedScopes.entries()).map(([category, scopes]) => (
        <div key={category} className='mb-4'>
          <h6 className='text-uppercase fw-bold small mb-2'>{category}</h6>
          {scopes.map((scope) => (
            <OAuth2AppsPermissionRow
              key={scope.id}
              scope={scope.id}
              description={scope.description}
              isEditMode={!readOnly}
              isChecked={selectedScopes.includes(scope.id)}
              onToggle={onToggle}
            />
          ))}
        </div>
      ))}
    </>
  )
}
